export default "__VITE_ASSET__e77b1011__"